import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-language-arrow",
  "use": "icon-nav-language-arrow-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" fill=\"none\" id=\"icon-nav-language-arrow\">\n  <path d=\"M1.75049 2.87695L4.00049 5.12695L6.25049 2.87695\" stroke=\"#1D1D1D\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol